import { useTransformSectionToGoalMutation } from 'shared/hooks/queries/use-transform-section-to-goal-mutation';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export type TransformSectionToGoalOptions = {
  goal: Goal;
  isSubGoal?: boolean;
};

export const useTransformSectionToGoal = () => {
  const { mutateAsync } = useTransformSectionToGoalMutation();
  const links = useEntityLinks();
  return (sectionId: ID, { goal, isSubGoal }: TransformSectionToGoalOptions) =>
    mutateAsync({ goal, sectionId, isSubGoal, links });
};
